import {Box, Dialog, DialogTitle, makeStyles, Paper, Typography} from '@material-ui/core';
import React from "react";

type Props = {
    handleClose : (state : boolean) => void;
    open : boolean;
};

const useStyles = makeStyles(theme => ({
    ptb: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
}));

const CapacityInfoModal : React.FC<Props> = ({open, handleClose} : Props) => {
    const classes = useStyles();
    return <Dialog onClose={()=> handleClose(false)} aria-labelledby="capacity-info-title" open={open}>
        <DialogTitle id="capacity-info-title">Suggested Weekly Capacity</DialogTitle>
        <Box m={3}>
            <Box sx={{fontSize: '16px'}}><Box fontWeight='bold' display='inline'>Suggested Weekly Capacity</Box> is a real time calculation of your available capacity for a work week. Suggested Weekly Capacity leverages your fiscal-month capacity-per-day from the My Capacity tool.</Box>
            <Typography className={classes.ptb}>Fiscal-month capacity-per-day values are calculated using time off values from the scheduling view in favor of the projected time off values entered on the My Capacity view. Any additional internal time added, other than Time Off, on the Scheduling view will not reduce capacity for the work week. Finally, for weeks that span fiscal months, an average of fiscal-month capacity-per-day will be calculated and used to reduce capacity for time off.</Typography>
            <Typography className={classes.ptb}>Suggested Weekly Capacity = ROUND(SUM(Fiscal-Month Capacity-Per-Day) - ((Time Off / 8) * Fiscal-Month Capacity-Per-Day Average))”.</Typography>
        </Box>
    </Dialog>
}


export default CapacityInfoModal;
